// @ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';

import { ProblemWebService } from './types';

export function isWebserviceProblem(problem: { type: string } | null | undefined): problem is ProblemWebService {
    return problem?.type === PROBLEM_INNER_TYPES.WEB_SERVICE;
}
